<!--
 * @Author: hongye
 * @Date: 2020-09-23 13:57:17
 * @LastEditTime: 2020-09-23 16:01:46
 * @Description: 
-->
<template>
  <div>
    <el-table v-if="codeList.length"  :data="codeList" border style="width:100%;border-radius: 4px;" max-height="600px">
      <el-table-column prop="code" :label="$lang('国家/地区code')"></el-table-column>
      <el-table-column prop="msg" :label="$lang('描述')"></el-table-column>
    </el-table>
  </div>
</template>

<script>
const codeList = [
    { code:"SIN",msg:"SINGAPORE" },
    { code:"VNM",msg:"VIETNAM" },
    { code:"BWM",msg:"BRUNEI" },
    { code:"IDN",msg:"INDONESIA" },
    { code:"CHN",msg:"CHINA" },
    { code:"THA",msg:"THAILAND" },
    { code:"PHL",msg:"PHILIPPINES" },
]

export default {
  props: {
    dataList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data(){
      return{
          codeList:[...codeList,...this.dataList]
      }
  }
};
</script>

<style>
</style>